module.exports = __webpack_public_path__ + "img/number-black-11.5c8840bd.png";